import { LoginMethod } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

const Login = () => import('../views/custom/guangdong/Login.vue')
const Dashboard = () => import('../views/custom/guangdong/Dashboard.vue')
const DashboardFull = () => import('../views/custom/competition/Dashboard.vue')

export const loginRoute: RouteConfig = {
  path: 'competition/login',
  name: 'custom_competition_login',
  component: Login,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    ignoreLogin: true,
  },
}

export const dashboardRoute: RouteConfig = {
  path: 'competition/dashboard',
  name: 'custom_competition_dashboard',
  component: Dashboard,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const dashbaordFullRoute: RouteConfig = {
  path: 'competition/dashboard-full',
  name: 'custom_competition_dashboard_full',
  component: DashboardFull,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [loginRoute, dashboardRoute, dashbaordFullRoute]

export function navigateToCustomCompetitionLogin(router: VueRouter, loginMethod?: LoginMethod) {
  router.push({ name: loginRoute.name, query: { loginMethod } })
}

export function redirectToCustomCompetitionLogin(router: VueRouter, loginMethod?: LoginMethod) {
  router.replace({ name: loginRoute.name, query: { loginMethod } })
}

export function navigateToCustomCompetitionDashboard(router: VueRouter, id: string) {
  router.push({ path: dashboardRoute.path, query: { id } })
}

export function navigateToCustomCompetitionDashboardFull(router: VueRouter, id: string) {
  router.push({ path: dashbaordFullRoute.path, query: { id } })
}
